<div class="card modern-card d-flex flex-column">
  <div class="card-header border-0 bg-transparent pt-3 px-4">
    <div class="d-flex justify-content-between align-items-center">
      <div class="header-content">
        @if (!isEditingName) {
          <h1 class="modern-header">
            Bound Book
            @if (sharedService.selected_boundbook.boundbook_name) {
              <span
                style="color: #BDBDBD;"
                >{{ sharedService.selected_boundbook.boundbook_name }}</span
                >
              }
              <i
                class="fa-solid fa-pen-to-square edit-icon"
                (click)="startEditName()"
                title="Rename Book"
              ></i>
            </h1>
          }

          @if (isEditingName) {
            <div class="edit-mode-container">
              <input
                [(ngModel)]="tempName"
                class="modern-input"
                (keyup.enter)="saveName()"
                (keyup.escape)="cancelEdit()"
                #nameInput
                autofocus
                placeholder="Enter book name..."
                />
                <div class="edit-actions ms-2">
                  <button class="icon-btn success" (click)="saveName()" title="Save">
                    <i class="fa fa-check"></i>
                  </button>
                  <button
                    class="icon-btn danger"
                    (click)="cancelEdit()"
                    title="Cancel"
                    >
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              </div>
            }
          </div>

          <div class="header-actions">
            <button
              type="button"
              class="close-btn"
              (click)="openHome()"
              title="Close"
              >
              <i class="fa-solid fa-xmark"></i>
            </button>
          </div>
        </div>

        <div
          class="action-bar mt-3 d-flex justify-content-between align-items-center bg-dark-subtle rounded-3"
          >
          <div class="left-actions">
            <button
              type="button"
              class="btn modern-btn blue-btn refresh-btn btn-sm"
              (click)="refreshTableDataClick()"
              >
              <i class="fa-solid fa-rotate me-2"></i>Refresh Table
            </button>
          </div>

          <div class="right-actions d-flex gap-2">
            <div class="btn-group" dropdown container="body" placement="bottom right">
              <button
                dropdownToggle
                type="button"
                class="btn modern-btn grey-btn dropdown-toggle btn-sm"
                >
                New Actions
              </button>
              <ul
                *dropdownMenu
                class="dropdown-menu dropdown-menu-dark modern-dropdown shadow-lg dropdown-menu-end"
                >
                <li>
                  <a
                    class="dropdown-item"
                    [class.disabled]="!rowData?.length"
                    (click)="createAcquisitionClick()"
                    ><i class="fa-solid fa-plus me-2"></i>Create Acquisition</a
                    >
                  </li>
                  <li>
                    <a
                      class="dropdown-item"
                      [class.disabled]="!rowData?.length"
                      (click)="createBulkAcquisitionClick()"
                      ><i class="fa-solid fa-layer-group me-2"></i>Create Bulk
                      Acquisition</a
                      >
                    </li>
                    <li>
                      <a
                        class="dropdown-item"
                        [class.disabled]="!rowData?.length"
                        (click)="createDispositionClick()"
                        ><i class="fa-solid fa-arrow-right-from-bracket me-2"></i>Create
                        Disposition</a
                        >
                      </li>
                      <li class="dropdown-divider"></li>
                      <li>
                        <a
                          class="dropdown-item"
                          [class.disabled]="!rowData?.length"
                          (click)="createBoundBookPrintableClick()"
                          ><i class="fa-solid fa-print me-2"></i>Print Bound Book</a
                          >
                        </li>
                        <li class="dropdown-divider"></li>
                        <li>
                          <a
                            class="dropdown-item"
                            (click)="saveCurrentTablePreferencesClick()"
                            ><i class="fa-solid fa-floppy-disk me-2"></i>Save Table
                            Settings</a
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card-body p-0 d-flex flex-column flex-grow-1">
                <ag-grid-angular
                  #grid
                  id="dispo_list"
                  class="modern-grid flex-grow-1"
                  style="width: 100%; height: 100%"
                  
                  [columnDefs]="columnDefs"
                  [defaultColDef]="defaultColDef"
                  [gridOptions]="gridOptions"
                  [rowData]="rowData"
                  [animateRows]="true"
                  [rowSelection]="rowSelection"
                  [components]="components"
                  [enableBrowserTooltips]="true"
                  [preventDefaultOnContextMenu]="true"
                  (gridReady)="onGridReady($event)"
                  (cellContextMenu)="onCellContextMenu($event)"
                  (filterChanged)="storeCurrentSessionFilters()"
                  (columnPinned)="storeCurrentSessionColumnConfig()"
                  (columnResized)="storeCurrentSessionColumnConfig()"
                  (columnMoved)="storeCurrentSessionColumnConfig()"
                  (sortChanged)="storeCurrentSessionColumnConfig()"
                ></ag-grid-angular>
              </div>
            </div>

            <!-- Added for the right click "Copy" function -->
            @if ((menuState$ | async)?.showMenu) {
              <div
                class="custom-context-menu"
                [style.top.px]="(menuState$ | async)?.menuTop"
                [style.left.px]="(menuState$ | async)?.menuLeft"
                (click)="copyCellValue()"
                (mouseenter)="onMenuMouseEnter()"
                (mouseleave)="onMenuMouseLeave()"
                >
                <i class="fa-solid fa-copy me-2"></i> Copy
              </div>
            }
